import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

interface PrivateCharityRouteProps {
  children: JSX.Element;
}

const PrivateCharityRoute: React.FC<PrivateCharityRouteProps> = ({ children }) => {
  const currentCharityId = useSelector((state: RootState) => state.auth.currentCharityId)

  if (!currentCharityId) {
    return <Navigate to="/charity" replace />;
  }

  return children
};

export default PrivateCharityRoute;
